module.exports = __webpack_public_path__ + "img/pc-bg02-mobile.3b28645b.png";